import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import baseMessage from './components/baseMessage.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import tabsContract from '@/views/overseasSales/customerCenter/components/tabsContract.vue'
import tabsBusiness from '@/views/overseasSales/customerCenter/components/tabsBusiness.vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const permissionBuss = {
  add: 'ofbu_arkcode_buss_add_btn',
  edit: 'ofbu_arkcode_buss_edit_btn',
  del: 'ofbu_arkcode_buss_del_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: _unref(t)('common.baseTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        id: _unref(route).query.id,
                        returnName: "DcCosOFbuAccountCode"
                      }, null, 8, ["id"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: _unref(t)('common.bussiessTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsBusiness, {
                        returnName: "DcCosOFbuAccountCode",
                        arkCodeId: _unref(route).query.id,
                        permissionPage: permissionBuss
                      }, null, 8, ["arkCodeId"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: _unref(t)('common.contractTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsContract, { returnName: "DcCosOFbuAccountCode" })
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    tab: _unref(t)('common.conversionTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsConversion), {
                        resourceId: _unref(route).query.id,
                        appId: "cos_ofbu"
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "5",
                    tab: _unref(t)('common.operationLogTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        appId: "cos_ofbu",
                        tableId: "DcCosOFbuAccountCodeOperationLog",
                        resourceId: _unref(route).query.id
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }, 8, ["tab"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_cos_footer_button, {
            disabled: true,
            hideOk: true
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})